module.exports = __webpack_public_path__ + "static/media/Square_Logotype_white.7e50f9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Square_Logotype_white.png
// module id = 947
// module chunks = 0